import React, { useContext, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';
// Context
// import useCallPerformanceContext from '../context/useCallPerformanceContext';
import useFieldEngagementContext from '../context/useFieldEngagementContext';

/* eslint-disable react/prop-types */
export default function FieldReportTable({ loading, data }) {
  const { handleFieldDetailsData } = useContext(useFieldEngagementContext);
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'user_name',
      headerName: 'Account Specialist',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        row.user_id !== null ? (
          <Button onClick={() => handleFieldDetailsData(row)} variant='text'>
            {row.user_name}
          </Button>
        ) : (
          row.user_name
        ),
    },
    {
      field: 'target',
      headerName: 'Target',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.target),
    },
    {
      field: 'actual',
      headerName: 'Actual',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.actual),
    },
    {
      field: 'perf',
      headerName: 'Perf %',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        `${Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.perf)}%`,
    },
  ];
  const pinnedRows = {
    bottom: data?.length ? [data[0]] : [],
  };
  return (
    <div>
      <Box
        className='table-container'
        sx={{
          height: `930px`,
          '& .super-app-theme--header': {
            backgroundColor: '#6B8D3E',
            color: '#fff',
          },
          '& .manager_total': {
            backgroundColor: '#f1d0bdff',
          },

          '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#6B8D3E' },
        }}
      >
        <DataGridPro
          loading={loading}
          rows={data}
          columns={columns}
          sortModel={sortModel}
          experimentalFeatures={{ rowPinning: true }}
          initialState={{
            ...data.initialState,
            pagination: {
              pageSize: 50,
            },
            aggregation: {
              model: {
                target: 'sum',
              },
            },
          }}
          pinnedRows={pinnedRows}
          rowsPerPageOptions={[10, 25, 50]}
          pagination
          onSortModelChange={(model) => setSortModel(model)}
          getRowClassName={(params) => params?.row?.user_type}
        />
      </Box>
    </div>
  );
}
